export const languageData = {
    my: {
        title: "ဘာသာစကားဆိုင်ရာ မူဝါဒ",
        subtitle: "သံဃာညီညွတ်ရေးအတွက် အဓိက အချက်",
        sections: [
            {
                title: "စုံလင်ကွဲပြားသော ဒေသများမှ",
                content: "မဟာဝိဟာရကျောင်းတိုက်သည် တိုင်းနှင့် ပြည်နယ် အသီးသီးမှ ကြွရောက်လာကြသော ရဟန်း, သာမဏေများ စုပေါင်း၍ နေထိုင်ရာ ကျောင်းတိုက်တစ်ခု ဖြစ်၏။"
            },
            {
                title: "အဓိက စည်းကမ်းချက်",
                content: "သံဃာညီညွတ်ရေးအတွက် ဤကျောင်းတိုက်၏ အဓိကစည်းကမ်းချက်မှာ မိမိတို့ တိုင်းရင်းသားဘာသာ စကားကို မပြောကြဘဲ အများနားလည်သည့် မြန်မာစကားကိုသာ ပြောဆိုကြရခြင်း ဖြစ်၏။",
                reason: "အများနားမလည်နိုင်သည့် ဘာသာစကားဖြင့် ပြောလျှင် အထင်လွဲမှုများ ဖြစ်တတ်၍ အုပ်စုဖွဲ့ကာ စိတ်ဝမ်းကွဲတတ်၏။"
            },
            {
                title: "အာမခံဆရာစနစ်၏ အရေးပါမှု",
                content: "လူမျိုးခွဲခြားခြင်းမပြုဘဲ ညီညွတ်စေသော အခြားအချက်မှာ အာမခံဆရာစနစ်ဖြစ်သည်၊ အာမခံဆရာနှင့် အာမခံ တပည့်သည် လူမျိုးမတူညီသည့် ဆရာတပည့်များ ဖြစ်ကြ၍ အချင်းချင်း စေတနာ မေတ္တာ အပြန်အလှန်ထားကြသည့်အတွက် စိတ်ဝမ်း ကွဲစရာ မညီညွတ်စရာအကြောင်း မရှိတော့ပေ။"
            }
        ]
    },
    en: {
        title: "Language Policy",
        subtitle: "Key to Sangha Unity",
        sections: [
            {
                title: "Diverse Regional Representation",
                content: "Mahãvihãra Monastery is home to monks and novices who come from various states and regions across the country."
            },
            {
                title: "Core Policy",
                content: "A fundamental rule for maintaining unity among the Sangha is that everyone must communicate in Myanmar language, which is understood by all, rather than using their native ethnic languages.",
                reason: "Using languages that aren't understood by everyone can lead to misunderstandings and create divided groups, potentially causing disharmony."
            },
            {
                title: "Guardian Teacher System's Role",
                content: "Another factor promoting unity without ethnic discrimination is the Guardian Teacher system. Guardian Teachers and their disciples often come from different ethnic backgrounds, fostering mutual loving-kindness and eliminating causes for division or disharmony."
            }
        ]
    }
};